<template class="section">
    <div class="container" :id="container_id">
        <div class="columns">
            <b-alert 
                v-model="alert.show" 
                :variant="alert.variant || 'info'" 
                id="login-alert"
                dismissible 
            >{{alert.message}}</b-alert>

            <h3 class="my-4">Account Set-up</h3>

            <div class="column is-8 is-offset-2">
                <stepper 
                    :steps="steps" 
                    :model="model"
                    :reset="reset"
                    :setStep ="activeStep"

                    @completed-step="completeStep"
                    @active-step="isStepActive" 
                    @stepper-finished="submit"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import { installation_request } from '../../networking/installations'
    import { get_device_by_imei } from '../../networking/devices'

    import Stepper from './../../widgets/Stepper'

    import AccountStep from './AccountStep'
    import AddressStep from './AddressStep'
    import InstallationStep from './InstallationStep'

    const container_id = 'create_installation_container'
    const default_error_msg = 'Device subscription failed'
    const validation_error_message = tab => `Please complete the missing ${tab} fields`

    export default {
        name: 'InstallationStepper',
        components: { Stepper },
        props:{ 
            installation_options:{ type: Object },
            userData: Object,
            imei: String
        },

        data(){
            return {
                reset: false,
                activeStep: null,
                model: { 
                    account:{}, 
                    address:{}, 
                    device:{}, 
                    installation:{}, 
                    user:{},
                    existent_users: [],
                    existent_user: {}
                },

                alert: { show:false, message:'', variant:'' },
                steps: [
                    {
                        icon: 'person',
                        name: 'first',
                        title: '1. Account Info',
                        component: AccountStep,
                        completed: false,
                        canContinue: true
                    }, {
                        icon: 'mail',
                        name: 'second',
                        title: '2. Address Info',
                        component: AddressStep,
                        completed: false,
                        canContinue: true
                    }, {
                        icon: 'build',
                        name: 'third',
                        title: '3. Install Info',
                        component: InstallationStep,
                        completed: false,
                        canContinue: true,
                    }
                ],

                container_id: container_id
            }
        },

        async created(){
            this.model = {...this.model, ...this.installation_options}
            this.retrieve_device()
         },

        methods: {
            async retrieve_device(){
                const { value: { data = {} }} = await get_device_by_imei(this.imei)
                this.model.device.id = data.id
                this.model.device.imei = this.imei
            },

            // Executed when @stepper-finished event is triggered
            async submit(){
                document
                .getElementById(container_id)
                .scrollIntoView({ behavior: 'smooth' })
                
                try {
                    this.validate_fields()
                    const data = await this.createInstallation()
                    this.alert = {show: true, message: "Success!", variant: 'success'}
                    setTimeout(() => 
                        this.$router.push(`/selfinstall/device/${data.device.imei}`), 5000
                    )

                } catch(e){ 
                    this.alert = {
                        show: true, 
                        message: e.message || default_error_msg, 
                        variant: e.variant || 'danger', 
                    }
                }
            },

            validate_fields(){
                const { first_name, last_name, email } = this.model.user
                const { line_1, line_2, city, state, zip } = this.model.address
                const { 
                    valve_control_enabled, 
                    location_type, 
                    service_type, 
                    meter_size, 
                    meter_type, 
                    make 
                } = this.model.installation
                if (email) {
                    this.model.account.name = email
                }
                if(
                    (!this.model.account.name || !first_name || !last_name || !email)
                    && !this.model.existent_user.account_id
                ){
                    this.reset = true
                    throw { message: validation_error_message('account'), variant: 'info' }

                } else if ( !line_1 || !city || !state || !zip){
                    this.activeStep = 1
                    throw { message: validation_error_message('address'), variant: 'info' }

                } else if (!this.model.device.name){ 
                    throw { message: validation_error_message('installation'), variant: 'info' }

                } else {
                    this.alert = { show: true, message: 'Waiting for Response...' }
                }
            },

            async createInstallation(){
 
                const { account, address, device, installation, user } = this.model
                const body = { 
                    account, 
                    address, 
                    device, 
                    installation, 
                    user 
                }

                const generator = installation_request('POST', body)
                const { value: { alert = { variant: 'danger' }, data = {}}} = await generator.next()
                if(alert.variant === 'danger' ){ throw { message: alert.message }}
                else { return data }
            },

            // Executed when @completed-step event is triggered
            completeStep(payload){
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        step.completed = true
                    }
                })
            },

            // Executed when @active-step event is triggered
            isStepActive(payload){
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        if(step.completed === true) {
                            step.completed = false
                        }
                    }
                })
            },
        }
    }

</script>
